import { FileTextOutlined } from '@ant-design/icons';
import type { NavigationItemType } from '~/types/navigation';

export default {
    id: 'purchase-orders',
    title: 'Narudžbe dobavljaču',
    icon: FileTextOutlined,
    type: 'item',
    url: '/purchase-orders',
} satisfies NavigationItemType;
